<div class="fit-ira-height full-width-container" appAppBrowserDetect>
  <!-- <app-header></app-header> -->
  @if(pageFromPreview == 'preview'){
  <app-header
    [isRowVisible]="isRowVisible"
    [pageSource]="'IRA'"
    [pageData]="routeData"
    [showBreadcrumbs]="true"
  >
  </app-header>
  }
  <div class="section" *ngIf="!hideHeader">
    <div class="row" class="row-colour" style="position: relative">
      <img  src="assets/images/icons/translate-clicked.svg" style="display: none" >
      <img  src="assets/images/icons/translate.svg"  alt="Translation-Icon"  style="display: none" />
      <img  src="assets/images/icons/ira-translate.svg" style="display: none" >
      <img  src="assets/images/icons/ira-icon.svg"  alt="Translation-Icon"  style="display: none" />
      <img src="assets/images/icons/sub-icon.svg" style="display: none" />
      <div class="col-sm translate-sec" *ngIf="isRowVisible || rowVisibleIra">
        <div
          class="box"
          (click)="toggleTranslationGroup()"
          style="padding-bottom: 13px; border-radius: 0px 0px 0px 7px"
        >
            <img
            src="assets/images/icons/translate-clicked.svg"
            alt="Translation-Icon"
            [style.display]="showTranlsationGroup ? 'inline' : 'none'"
            />
            <img
            src="assets/images/icons/translate.svg"
            alt="Translation-Icon"
            [style.display]="!showTranlsationGroup ? 'inline' : 'none'"
            />
          <span
            [ngStyle]="{ color: showTranlsationGroup ? '#F3D16A' : '#8895e7' }"
            >Translation</span
          >
        </div>

        <div
          *ngIf="showTranlsationGroup"
          class="box cursor-pointer box-radio-group"
        >
          <mat-radio-group aria-label="Select an option" class="radio-group">
            <mat-radio-button
              value="translation"
              (change)="toggle($event)"
              [checked]="radioBtnValue == 'translation'"
              [disabled]="isAnyRowEdited"
              >Translation</mat-radio-button
            >
            <mat-radio-button
              value="backtranslation"
              (change)="toggle($event)"
              [checked]="radioBtnValue == 'backtranslation'"
              [disabled]="isAnyRowEdited"
              >Back Translation</mat-radio-button
            >
          </mat-radio-group>

          <div class="dropdown-group">
            <div class="lang-div">
              <span style="color: #ffffff">Language</span>
              <select
                #language
                class="language-dropdown"
                (change)="onRadioButtonChange()"
                placeholder="Select a language"
                [disabled]="defaultLanguageDisbaled"
              >
                @for(language of languagesData; track language.language){
                <option value="undefined" hidden disabled>
                  Select Language
                </option>
                <option [ngValue]="language">
                  {{ language }}
                </option>
                }
              </select>
            </div>

            <button class="btn-add-translation">Add Translation</button>
          </div>
        </div>

        <div class="box" (click)="toggleIraGroup()">
            <img
            src="assets/images/icons/ira-translate.svg"
            alt="translate-icon"
            [style.display]="showLanguageGroup ? 'inline' : 'none'"
            />
            <img
            src="assets/images/icons/ira-icon.svg"
            alt="ira-icon"
            [style.display]="!showLanguageGroup ? 'inline' : 'none'"
            />

          <span
            [ngStyle]="{ color: showLanguageGroup ? '#F3D16A' : '#8895e7' }"
          >
            Intelligent Risk Assessment
          </span>
        </div>

        <div
          class="box cursor-pointer save-asset-group"
          *ngIf="showLanguageGroup"
          style="width: 15vw; background-color: transparent"
        >
          <!-- <button class="btn-save-asset" disabled>Save Asset Risk Value</button> -->
          <button
            [disabled]="this.eeocDocId === '0' ? true : false"
            [ngClass]="{
              'common-disabled-colour': this.eeocDocId === '0',
              'btn-save-asset': this.eeocDocId !== '0'
            }"
            (click)="populateOverallResult()"
            [matTooltipClass]="'rule-tooltip'"
            matTooltip="Save the Overall Risk of the Asset in Veeva for the chosen metadata without saving the individual claim risk value"
          >
            Save Asset Risk Value
          </button>

          <div class="ira-button-group">
            <button class="btn-export" [matMenuTriggerFor]="export">
              Export
            </button>
            <mat-menu #export="matMenu" yPosition="below">
              <button mat-menu-item (click)="exportPdf()">PDF</button>
              <button mat-menu-item (click)="exportExcel()">Excel</button>
            </mat-menu>

            <button
              class="btn-export"
              [matMenuTriggerFor]="saveAs"
              [disabled]="this.eeocDocId === '0' ? true : false"
            >
              Save As
            </button>
            <mat-menu #saveAs="matMenu" yPosition="below">
              <button mat-menu-item (click)="saveasPDF()">PDF</button>
              <button mat-menu-item (click)="saveasExcel()">Excel</button>
            </mat-menu>
          </div>
        </div>

        <div class="box">
          <img src="assets/images/icons/sub-icon.svg" alt="" />
          <span> Support & Substantiation</span>
        </div>
      </div>

      <div
        class="half-circle"
        (click)="toggleRow()"
        [class.disabled]="pageFromPreview === 'preview'"
      >
        <img src="assets/images/icons/half-circle.svg" alt="" />
        <!-- <mat-icon
          class="circle-dropdown-icon"
          [ngClass]="{ rotated: !isRowVisible }"
        >
          keyboard_arrow_up
        </mat-icon> -->
      </div>
    </div>
  </div>
  <div
    *ngIf="!hideHeader"
    class="row"
    style="margin-top: 10px; margin-right: 0px; margin-left: 0px"
  >
    <div class="col-sm-3">
      <div class="metadata-header">
        <div class="legend-icon"></div>
        <span class="metadata-title">Claims</span>
      </div>
    </div>

    <div class="col-sm-9">
      <div class="row">
        <div class="master-flow">
          <!-- <div class="legend-1"></div>
          <div class="legend-2"></div>
          <div class="legend-3"></div> -->

          <!-- <img
            style="height: 21px; width: 21px; margin-right: 14px"
            (click)="wrapStatementandQualifiertext()"
            src="assets/images/icons/wraptextImage.png"
          /> -->

          <!-- Image 1: wraptextImage.svg -->
          <img
            *ngIf="isTruncated"
            style="height: 28px; width: 28px; cursor: pointer"
            src="assets/images/icons/wraptextImage.svg"
            (click)="wrapStatementandQualifiertext()"
          />

          <!-- Image 2: wrap-text-success.svg -->
          <img
            *ngIf="!isTruncated"
            style="height: 18px; width: 18px; cursor: pointer"
            src="assets/images/icons/wrap-text-success.svg"
            (click)="wrapStatementandQualifiertext()"
          />
          <!-- <img src="assets/fonts/scanner.png" /> -->
          <!-- <button mat-stroked-button class="btn-text-format">
            Format Qualifiers
          </button> -->

          <button
            mat-stroked-button
            class="btn-text-reset"
            (click)="resetAll()"
          >
            Reset All
          </button>

          <button
            mat-stroked-button
            btn-text-proceed-asset
            class="btn-text-project"
            [disabled]="this.eeocDocId === '0' ? true : false"
            [ngClass]="{
              'common-disabled-colour': this.eeocDocId === '0',
              'btn-save-asset': this.eeocDocId !== '0'
            }"
            color="primary"
            (click)="populateOverallResult()"
            [matTooltipClass]="'rule-tooltip'"
            matTooltip="Save the Overall Risk of the Asset in Veeva for the chosen metadata without saving the individual claim risk value"
          >
            Save Asset Risk Value
          </button>
          @if(pageFromPreview != 'preview'){
          <button
            (click)="formatQualifier()"
            mat-stroked-button
            [ngClass]="{
              'btn-disabled-text-format': isFormatted,
              'btn-text-format': !isFormatted
            }"
            [disabled]="isFormatted"
          >
            Format Qualifiers/Disclaimers
          </button>
          }
          <!-- <button
            mat-stroked-button
            class="btn-text-project"
            (click)="retakeAssessment()"
          >
            Retake Assessment
          </button> -->
          <!-- [disabled]="!isTextModified"
            [ngClass]="{ 'common-disabled-colour': !isTextModified }" -->
          <button
            mat-stroked-button
            disabled
            [ngClass]="{ 'common-disabled-colour': true }"
            class="btn-text-project"
            (click)="retakeAssessment()"
          >
            Retake Assessment
          </button>

          <!-- <button mat-stroked-button class="btn-text-project">
            Save In Project
          </button> -->
          <!-- Proceed Button with Dropdown -->
          <!-- Proceed Button with Dropdown -->
          <!-- Proceed Button -->
          <!-- Proceed Button -->
          <!-- <button
            mat-stroked-button
            class="btn-text-project"
            [matMenuTriggerFor]="proceedMenu"
          >
            Proceed
          </button> -->
          <!-- [ngClass]="{ 'common-disabled-colour': activeClaimsCount > 0 }"
          [disabled]="activeClaimsCount > 0" -->

          <button
            mat-stroked-button
            class="btn-text-project"
            [disabled]="isTextModified"
            [ngClass]="{ 'common-disabled-colour': isTextModified }"
            [matMenuTriggerFor]="proceedMenu"
          >
            Proceed
          </button>

          <!-- Main Proceed Menu -->
          <mat-menu #proceedMenu="matMenu" yPosition="below">
            <button
              mat-menu-item
              class="nested-menu-trigger"
              (click)="onBulkEntry()"
            >
              Enter Claims/LA
            </button>

            <!-- Export with Nested Menu -->
            <button
              mat-menu-item
              [matMenuTriggerFor]="exportMenu"
              class="nested-menu-trigger"
            >
              Export
            </button>

            <button
              mat-menu-item
              [matMenuTriggerFor]="saveAsMenu"
              class="nested-menu-trigger"
              [disabled]="this.eeocDocId === '0' ? true : false"
            >
              Save As
            </button>
          </mat-menu>

          <!-- Export Submenu -->
          <mat-menu #exportMenu="matMenu">
            <button mat-menu-item (click)="exportPdf()">PDF</button>
            <button mat-menu-item (click)="exportExcel()">Excel</button>
          </mat-menu>

          <!-- Save As Submenu -->
          <mat-menu #saveAsMenu="matMenu">
            <button mat-menu-item (click)="saveasPDF()">PDF</button>
            <button mat-menu-item (click)="saveasExcel()">Excel</button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>

  <div class="row" style="margin: 10px 0" *ngIf="activeClaimsCount > 0">
    <div class="col-sm">
      <div class="claim-alert">
        <span style="margin-right: 5px">
          {{ activeClaimsCount }} Claims to review
        </span>

        <img
          *ngIf="activeClaimsCount > 0"
          src="assets/images/icons/alert-circle-outline.png"
          alt="Search"
          style="width: 15px; height: 15px; margin: 2px 5px 0 0"
        />
      </div>
    </div>
  </div>

  <!-- <mat-toolbar class="claims-toolbar">
    <span class="claims-title">Claims</span>
    <button mat-menu-item [matMenuTriggerFor]="export">Export</button>
    <mat-menu #export="matMenu">
      <button mat-menu-item (click)="exportPdf()">
        <mat-icon>picture_as_pdf</mat-icon>PDF
      </button>
      <button mat-menu-item (click)="exportExcel()">
        <i class="fa fa-file-excel-o" aria-hidden="true"></i
        >&nbsp;&nbsp;&nbsp;Excel
      </button>
    </mat-menu>
    <span class="claims-title">Claims</span>
    <span class="claims-title">Claims</span>
    <button (click)="truncateAllQualifiers()">
      <img src="assets/fonts/text-block.png" alt="Truncate All" />
    </button>
    <button class="button-box">Retake Assessment</button>
  </mat-toolbar> -->
  <!-- <div
    #tableContainer
    [ngClass]="{
      tableContainer_translated_RowVisible: isResultPage,
      tableContainer_translate_RowVisible: !isResultPage && !isRowVisible,
      tableContainer: !isResultPage && isRowVisible,
   tableContainer_translated_RowHidden: isResultPage && !isRowVisible
    }"
  > -->
  <!-- <div
    #tableContainer
    [ngClass]="{
      tableContainer_translated_RowVisible: isResultPage && rowVisibleIra,
      tableContainer_translated_RowHidden: isResultPage && !rowVisibleIra,
      activeClaimsCount_rowhidden: isResultPage && !rowVisibleIra && (activeClaimsCount > 0),
      activeClaimsCount_rowVisible: isResultPage && rowVisibleIra && (activeClaimsCount > 0),
      tableContainer_translate_RowVisible: !isResultPage && !isRowVisible,
      tableContainer: !isResultPage && isRowVisible
    }"
  > -->
  <div #tableContainer [ngClass]="getTableContainerClass()">
    <table mat-table [dataSource]="dataSource">
      <!-- @if(pageFromPreview == 'preview'){ -->
      <ng-container matColumnDef="checkbox" sticky>
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </th>

        <td mat-cell *matCellDef="let element; let i = index">
          <div
            [ngStyle]="
                                  element.isNewRow
                                    ? {
                                        display: 'flex',
                                        alignItems: 'center',
                                       
                                      }
                                    : {}
                                "
          >
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? changeSelection(element, i) : null"
              [checked]="selection.isSelected(element)"
            >
            </mat-checkbox>
            <img
              *ngIf="element.isNewRow == true"
              src="assets/images/icons/delete.png"
              alt="delete icon"
              style="cursor: pointer; height: 12px; margin-left: 0px"
              title="Delete row"
              (click)="confirmDeleteRow(i, '30%')"
            />
          </div>
        </td>
      </ng-container>
      <!-- } -->
      <!-- src="assets/images/icons/alert-circle-outline.png" -->

      <!-- Sl.No Column -->
      <ng-container matColumnDef="slno" sticky>
        <th mat-header-cell *matHeaderCellDef>Sl.No</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div
            style="
              display: flex;
              justify-content: start;
              align-items: center;
              margin-top: 7px;
            "
            [ngClass]="radioBtnValue === 'translation' ? 'translated-slno' : ''"
          >
            <img
              *ngIf="element.matched_status == 'not matched'"
              src="assets/images/icons/alert-circle-outline.png"
              alt="alert icon"
              (click)="openLatestUpdatesPopup(element, i)"
              style="height: 15px; cursor: pointer"
            />

            <span>{{ element.sl_no }}</span>
          </div>
          <span
            *ngIf="element.isNew == true"
            [ngClass]="{
              sl_textarea_added: isFormatted,
              sl_dropdown_added: !isFormatted
            }"
          >
            {{ element.translation_sr_no }}</span
          >
        </td>
      </ng-container>
      <!--Statement Text Column-->
      <ng-container matColumnDef="text" sticky>
        <th
          mat-header-cell
          *matHeaderCellDef
          appClickOutside
          (clickOutside)="showStatementSearch = false"
        >
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 300px;
            "
          >
            <div class="table-header">
              <span
                [ngClass]="{
                  'header-text-highlight': textFilter.value
                }"
                >Statement Text</span
              >
            </div>
            <img
              src="assets/images/icons/search.svg"
              (click)="toggleStatementSearch()"
              style="width: 12px; height: 12px"
            />
          </div>

          <div
            *ngIf="showStatementSearch"
            class="flex justify-between items-center input-container"
          >
            <div class="flex text-search-container">
              <img
                src="assets/images/icons/search.svg"
                style="height: 12px; width: 12px"
              />

              <input
                #searchInput
                type="text"
                [formControl]="textFilter"
                class="search-input"
                placeholder="Search here..."
              />

              <img
                *ngIf="textFilter.value"
                src="assets/images/icons/close.png"
                (click)="clearSearch()"
                style="height: 14px; width: 14px"
              />
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <!-- <textarea
            *ngIf="element.text != 'NULL'"
            #textAreaRef
            matInput
            [(ngModel)]="element.text"
            [value]="element.truncatedText || element.text"
            matInput
            class="txt-area"
            [matTooltip]="element.text"
            (keyup)="editableText($event, i)"
            class="txt-area-statement"
            [ngStyle]="{
              height: isTruncated ? '6.5vh' : 'auto',
              overflow: isTruncated ? 'auto' : 'hidden',
              resize: 'none',
              
              paddingRight: '50px',
             
        
            }"
          >
          </textarea> -->
          <textarea
            *ngIf="element.text != 'NULL'"
            #textAreaRef
            matInput
            class="txt-area-statement"
            [(ngModel)]="element.text"
            [matTooltip]="element.text"
            (input)="!isTruncated && autoResize(textAreaRef)"
            (keyup)="editableText($event, i)"
            [ngStyle]="{
              cursor:
                element.draggedFromTable1 == true ||
                element.highlighted == true ||
                !element.editing_status_statement
                  ? 'not-allowed'
                  : 'text',
              height: isTruncated ? '3.6em' : '3.6em',
              overflow: isTruncated ? 'auto' : 'hidden',
              resize: 'none',
              paddingRight: '60px'
            }"
            [disabled]="
              element.draggedFromTable1 == true ||
              element.highlighted == true ||
              !element.editing_status_statement
            "
            style="width: 100%"
          ></textarea>

          <ng-container *ngIf="element.text == 'NULL'">
            <img
              src="{{ 'data:image/png;base64,' }}{{ element.image }}"
              class="image-class"
            />
          </ng-container>
          <img
            *ngIf="
              (element.isFieldsDisabled || element.isEdited) &&
              (element.isNewRow || element.isEdited)
            "
            [ngStyle]="{
              cursor: element.text.trim() !== '' ? 'pointer' : 'not-allowed',
            
            }"
            [matTooltip]="newRowHelpText"
            [src]="
              element.text.trim() !== ''
                ? 'assets/images/icons/content-save-blue.svg'
                : 'assets/images/icons/content-save-outline.png'
            "
            [ngClass]="{
              'addNew-row-close-icon': !element.isNew,
              'addNew-row-height': element.isNew,
              'addNew-new-row-close-height':
                element.isNewRow && relatedStatementChecked
            }"
            (click)="
              element.text.trim() !== '' &&
                getGlobalQualifiersMarketingChannels($event, i)
            "
          />

          <img
            *ngIf="
              (element.isFieldsDisabled || element.isEdited) &&
              (element.isNewRow || element.isEdited)
            "
            [matTooltip]="'Clear text'"
            src="assets/images/icons/close.png"
              [ngClass]="{
    'addNew-row-cloud-icon': !element.isNew,
    'addNew-row-cloud-height': element.isNew,
    'addNew-new-row-cloud-height': element.isNewRow && relatedStatementChecked
  }"
       
            (click)="element.text = ''"
          />
          <!-- statement text translation row -->
          <ng-container *ngIf="element.isNew == true">
            <div
              [ngClass]="{
                textarea_added: isFormatted,
                dropdown_added: !isFormatted
              }"
            >
              <p-dropdown
                [options]="element.translated_text"
                [matTooltip]="element.selected_translated_text"
                [(ngModel)]="element.selected_translated_text"
                [readonly]="btnClicked == false || element.highlighted == true"
                optionLabel="text"
                optionValue="text"
                placeholder="Select"
                (onChange)="
                  getSelectedTrasnlation(element.selected_translated_text, i)
                "
                appendTo="body"
                [editable]="btnClicked"
                class="translated-dropdown"
              >
                <ng-template let-statement pTemplate="item">
                  <div class="flex flex-row" style="margin-left: -10px">
                    <img
                      class="lang-change-img"
                      style="height: 15px"
                      [src]="statement.type == 'ai' ? statement.icon : ''"
                      alt=""
                      (load)="imageOnLoad($event, i, 'statement')"
                    />
                    <div
                      class="translated-text"
                      [matTooltip]="statement.text"
                      [matTooltipPosition]="
                        statement.type === 'ai' ? 'below' : 'above'
                      "
                    >
                      <ng-container
                        *ngIf="
                          showText['statement-' + i] || statement.type !== 'ai'
                        "
                        >{{ statement.text }}</ng-container
                      >
                    </div>
                  </div>
                </ng-template>
              </p-dropdown>

              <!-- <p-dropdown
                            [options]="cities"
                            [readonly]="btnClicked == false"
                            [matTooltip]="element.selected_translated_text"
                            [(ngModel)]="element.selected_translated_text"
                            optionLabel="name"
                            optionValue="name"
                            placeholder="Select"
                            (onChange)="getSelectedTrasnlation($event, i)"
                            appendTo="body"
                            editable="true"
                            class="custom-dropdown"
                          ></p-dropdown> -->
            </div>

            <!-- <ng-select
                        [ngStyle]="{
                          width: isChecked ? '100%' : '100%'
                        }"
                        [ngStyle]="{
                          'margin-top':
                            backtranslationChecked == true ? '2.5vh' : '2.5vh'
                        }"
                        [ngStyle]="{
                          'margin-top':
                            element.richtext == true ? '40px' : '40px'
                        }"
                        [ngStyle]="{
                          'margin-top': isFormatted == true ? '20px' : '2.2vh'
                        }"
                        [multiple]="false"
                        [addTag]="true"
                        addTagText="Add New"
                        appendTo="body"
                        style="position: relative; color: black; width: 100%"
                        (change)="getSelectedTrasnlation($event, i)"
                        [readonly]="btnClicked == false"
                        [matTooltip]="element.selected_translated_text"
                        [(ngModel)]="element.selected_translated_text"
                      >
                        <ng-option
                          style="font: 11px Inter Medium"
                          *ngFor="let translation of element.translated_text"
                          [value]="translation.text"
                          style="text-align: center"
                          ><img
                            src="assets/img/icons/azure-translator-1.png"
                            height="15"
                            class="material-symbols-outlined"
                            *ngIf="translation.icon != ''"
                          />
                          &nbsp;
                          <span [matTooltip]="translation.text">{{
                            translation.text
                          }}</span>
                        </ng-option>
                      </ng-select> -->
          </ng-container>
        </td>
      </ng-container>

      <!-- Qualifier Column -->
      <ng-container
        matColumnDef="qualifier"
        *ngIf="
          fileType !=
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        "
      >
        <th
          mat-header-cell
          *matHeaderCellDef
          appClickOutside
          (clickOutside)="showQualifierSearch = false"
        >
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 200px;
            "
            [ngStyle]="
              showQualifierSearch
                ? { 'padding-top': '12px', 'margin-top': '13px' }
                : {}
            "
          >
            <span
              [ngClass]="{
                'header-text-highlight': qualifierFilter.value
              }"
              >Qualifier/Disclaimer</span
            >
            <img
              src="assets/images/icons/search.svg"
              (click)="toggleQualifierSearch()"
              style="width: 12px; height: 12px"
            />
          </div>

          <!-- <mat-icon class="qualifier-icon" (click)="toggleQualifierSearch()"
        >search</mat-icon
      > -->
          <div
            *ngIf="showQualifierSearch"
            class="flex justify-between items-center input-container"
          >
            <div
              class="flex search-container"
              style="position: relative !important; margin-top: 0px !important"
            >
              <img
                src="assets/images/icons/search.svg"
                style="height: 12px; width: 12px"
              />
              <input
                #searchInput
                type="text"
                class="search-input"
                [formControl]="qualifierFilter"
                placeholder="Search here..."
              />
              <img
                *ngIf="qualifierFilter.value"
                src="assets/images/icons/close.png"
                (click)="clearQualifierSearch()"
                style="height: 14px; width: 14px"
              />
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div>
            <ng-container
              #tabledata
              *ngIf="isFormatted == false && element.editing_status_qualifier"
            >
              <mat-form-field
                appearance="outline"
                style="vertical-align: top; width: 100%; margin-top: 7px"
              >
                <mat-select
                  multiple
                  placeholder="Select Qualifiers"
                  [disabled]="
                    (element.isNewRow == true &&
                      element.isFieldsDisabled == true) ||
                    element.isEdited == true
                  "
                  (selectionChange)="getSelectedQualifiers($event, i)"
                  [formControl]="element?.qualifiersFormControl"
                  [matTooltip]="element.qualifiers"
                >
                  <mat-option
                    *ngFor="let qualifier of element.allQualifier"
                    [value]="qualifier.text | safeHtml"
                  >
                    <div style="display: flex; align-items: center">
                      <span
                        [innerHTML]="qualifier.text | safeHtml"
                        [matTooltip]="qualifier.text | safeHtml"
                        style="
                          display: inline-block;
                          max-width: 150px;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        "
                      ></span>

                      <!-- <img
                        *ngIf="qualifier?.type == 'old'"
                        src="assets/images/icons/round-information-outline-black-icon.svg"
                        height="13"
                        style="margin-left: 10px; height: 15px; width: 15px"
                        title="Existing Value"
                      /> -->
                    </div>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>

            <!-- text editor -->
            <ng-container
              #tabledata
              *ngIf="
                isFormatted == true &&
                element.richtext == false &&
                element.editing_status_qualifier
              "
            >
              <span style="width: 100%; display: flex">
                <!-- for other than master text -->
                <textarea
                  *ngIf="fileType != ''"
                  class="txt-area-qualifier"
                  (click)="enableEditor(element, i)"
                  [disabled]="
                    element.isFieldsDisabled == true || element.isEdited == true
                  "
                  matTooltip="{{ sanitizeHTML(element.qualifiers) }}"
                  >{{
                    sanitizeHTML(element.qualifiers) ||
                      sanitizeHTML(element.allQualifier[0]?.text)
                  }}
                      </textarea
                >

                <!-- for master text -->
                <textarea
                  *ngIf="fileType == ''"
                  class="txt-area-qualifier"
                  [innerHTML]="
                    (element.qualifiers == []
                      ? element.existing_qualifier
                      : element.qualifiers
                    ) | safeHtml
                  "
                  (click)="enableEditor(element, i)"
                  [disabled]="
                    element.isFieldsDisabled == true || element.isEdited == true
                  "
                >
                </textarea>
              </span>
            </ng-container>
            <!-- rich text editor -->
            <ng-container
              *ngIf="
                element.richtext == true && element.editing_status_qualifier
              "
            >
              <editor
                #editor
                apiKey="no-api-key"
                licenseKey="gpl"
                [init]="init"
                [disabled]="element.isEdited == true"
                [(ngModel)]="element.qualifiers"
                [class.editor-class]="false"
              ></editor>
            </ng-container>

            <!-- disable editor -->
            <ng-container #tabledata *ngIf="!element.editing_status_qualifier">
              <span
                class="txt-area-qualifier-disable"
                [innerHTML]="
                  (element.qualifier_veeva !== 'NA'
                    ? element.qualifier_veeva
                    : ''
                  ) | safeHtml
                "
                matTooltip="{{
                  sanitizeHTML(
                    element.qualifier_veeva !== 'NA'
                      ? element.qualifier_veeva
                      : ''
                  )
                }}"
              >
              </span>
            </ng-container>

            <!-- qualifier translation -->
            <ng-container *ngIf="element.isNew == true">
              <div class="qualifier-translate-class">
                <p-dropdown
                  [options]="element.translated_qualifier_text"
                  (onChange)="
                    getSelectedQualifierTrasnlation(
                      element.selected_translated_qualifier_text,
                      i
                    )
                  "
                  [readonly]="btnClicked == false"
                  [matTooltip]="element.selected_translated_qualifier_text"
                  [(ngModel)]="element.selected_translated_qualifier_text"
                  optionLabel="text"
                  optionValue="text"
                  placeholder="Select"
                  appendTo="body"
                  [editable]="btnClicked"
                  autoWidth="false"
                  class="translated-dropdown"
                >
                  <ng-template let-qualifier pTemplate="item">
                    <div class="flex flex-row" style="margin-left: -10px">
                      <img
                        class="lang-change-img"
                        style="height: 15px"
                        [src]="qualifier.type == 'ai' ? qualifier.icon : ''"
                        alt=""
                        (load)="imageOnLoad($event, i, 'qualifier')"
                      />
                      <div
                        class="qualifier-translated-text"
                        [matTooltip]="qualifier.text"
                        [matTooltipPosition]="
                          qualifier.type === 'ai' ? 'below' : 'above'
                        "
                      >
                        <ng-container
                          *ngIf="
                            showText['qualifier-' + i] ||
                            qualifier.type !== 'ai'
                          "
                          >{{ qualifier.text }}</ng-container
                        >
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>

              <!-- <ng-select
                        [ngStyle]="{
                          width: isChecked ? '100%' : '100%'
                        }"
                        [multiple]="false"
                        [addTag]="true"
                        addTagText="Add New"
                        appendTo="body"
                        style="position: relative; color: black"
                        [ngStyle]="{
                          'margin-top': isFormatted == true ? '5px' : '0px',
                          'margin-bottom':
                            backtranslationChecked == true ? '1vh' : '2vh',
                          width:
                            element.selected_translated_qualifier_text != ''
                              ? '16vw'
                              : '100%'
                        }"
                        (change)="getSelectedQualifierTrasnlation($event, i)"
                        [readonly]="btnClicked == false"
                        [matTooltip]="
                          element.selected_translated_qualifier_text
                        "
                        [(ngModel)]="element.selected_translated_qualifier_text"
                      >
                        <ng-option
                          style="font: 11px Inter Medium"
                          *ngFor="
                            let translation of element.translated_qualifier_text
                          "
                          [value]="translation.text"
                          style="text-align: center"
                          ><img
                            src="assets/img/icons/azure-translator-1.png"
                            height="15"
                            class="material-symbols-outlined"
                            *ngIf="translation.icon != ''"
                          />
                          &nbsp;
 
                          <span [matTooltip]="translation.text">{{
                            translation.text
                          }}</span>
                        </ng-option>
                      </ng-select> -->
            </ng-container>
          </div>
          <div></div>
        </td>
      </ng-container>

      <!-- backtranslation Column -->
      <ng-container matColumnDef="backtranslation">
        <th mat-header-cell *matHeaderCellDef>Back Translation</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <ng-container>
            <div class="back-translatedrow">
              <p-dropdown
                [options]="element.back_translated_text"
                [(ngModel)]="element.selected_back_translated_text"
                [matTooltip]="element.selected_back_translated_text"
                (change)="
                  getSelectedBackTrasnlation(
                    element.selected_back_translated_text,
                    i
                  );
                  isBackTranslationVisible = true
                "
                optionLabel="text"
                optionValue="text"
                placeholder="Select"
                appendTo="body"
                [readonly]="btnClicked == false || element.highlighted == true"
                [editable]="btnClicked"
                class="translated-dropdown"
              >
                <ng-template let-bt pTemplate="item">
                  <div class="flex flex-row" style="margin-left: -10px">
                    <img
                      class="lang-change-img"
                      style="height: 15px"
                      [src]="bt.type == 'ai' ? bt.icon : ''"
                      alt=""
                      (load)="imageOnLoad($event, i, 'bt')"
                    />
                    <div
                      [matTooltip]="bt.text"
                      [matTooltipPosition]="
                        bt.type === 'ai' ? 'below' : 'above'
                      "
                      class="bt-translated-text"
                    >
                      <ng-container
                        *ngIf="showText['bt-' + i] || bt.type !== 'ai'"
                        >{{ bt.text }}</ng-container
                      >
                    </div>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
          </ng-container>
        </td>
      </ng-container>

      <!-- Marketing Channel Column -->
      <ng-container matColumnDef="new_marketing_channel">
        <th
          mat-header-cell
          *matHeaderCellDef
          appClickOutside
          (clickOutside)="showMarketingFilter = false"
        >
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
            [ngStyle]="
              showMarketingFilter
                ? { 'padding-top': '12px', 'margin-top': '13px' }
                : {}
            "
          >
            <span
              [ngClass]="{
                'header-text-highlight': marketingFilter.value?.length > 0
              }"
            >
              Marketing Channel
            </span>
            <img
              src="assets/images/icons/filter.svg"
              style="height: 12px; width: 12px"
              (click)="toggleMarketingFilter()"
            />
          </div>
          <div
            *ngIf="showMarketingFilter"
            class="flex justify-between items-center input-container"
          >
            <div
              class="flex marketing-search-container"
              style="position: relative !important; margin-top: 0px !important"
            >
              <mat-select
                #marketingSelect
                (closed)="onMarketingChannelDropdownClosed()"
                [formControl]="marketingFilter"
                multiple
                placeholder="Filter Marketing"
              >
                <mat-option
                  *ngFor="let option of getUniquemarketingChannels()"
                  [value]="option"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          <!-- <mat-form-field appearance="outline" class="w-full">
            <mat-select
              [(ngModel)]="element.new_marketing_channel"
              multiple
              [disabled]="element.text.trim() !== element.originalText.trim()"
            >
              <mat-option
                *ngFor="let option of options_marketing"
                [value]="option"
                style="font-size: 10px"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
          <div>
            @if (element.editing_status_mc) {
            <div>
              <mat-form-field
                class="w-full"
                appearance="outline"
                style="margin-top: 7px"
              >
                <mat-select
                  [disabled]="
                    (element.isNewRow == true &&
                      element.isFieldsDisabled == true) ||
                    element.isEdited == true
                  "
                  (selectionChange)="getSelectedMarketingChannels($event, i)"
                  multiple
                  style="font-weight: 400; color: #49526e"
                  placeholder="Select Marketing Channel"
                  [(ngModel)]="element.allMarketingChannels"
                  [matTooltip]="element.allMarketingChannels"
                >
                  <mat-option
                    *ngFor="let market of marketingChannelsValues"
                    [value]="market.text"
                  >
                    <div style="display: flex; align-items: center">
                      <span>
                        {{ market.text }}
                      </span>
                      <!-- <span
                        *ngFor="
                          let existingmarketing of element.new_marketing_channel
                        "
                      >
                        <img
                          *ngIf="
                            element.master_exist == true &&
                            element.project_exist == true &&
                            market == existingmarketing
                          "
                          src="assets/img/icons/round-information-outline-black-icon.svg"
                          height="13"
                          style="margin-left: 10px"
                          title="Existing Value"
                        />
                      </span> -->
                    </div>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            } @else if(element.marketing_channels_veeva &&
            !element.editing_status_mc) {
            <div
              matTooltip="{{
                element.marketing_channels_veeva[0] !== 'NA'
                  ? element.marketing_channels_veeva
                  : ''
              }}"
            >
              {{
                element.marketing_channels_veeva[0] !== "NA"
                  ? element.marketing_channels_veeva
                  : ""
              }}
            </div>
            }

            <!-- <div
                    *ngIf="
                      element.editing_status.marketing_channels__c == false
                    "
                  >
                    {{ element.marketing_channel }}
                  </div> -->
          </div>
        </td>
      </ng-container>

      <!-- Lifecycle Column -->
      <ng-container matColumnDef="lifecycle">
        <th mat-header-cell *matHeaderCellDef>Lifecycle</th>
        <td mat-cell *matCellDef="let element">
          <div style="margin-top: 7px">
            {{ element.text_lifecycles_UI || element.assessed_state }}
          </div>
        </td>
      </ng-container>

      <!-- Page No Column -->
      <ng-container matColumnDef="page_no">
        <th mat-header-cell *matHeaderCellDef>Page No</th>
        <td mat-cell *matCellDef="let element">
          <div style="margin-top: 7px">{{ element.page_no }}</div>
        </td>
      </ng-container>

      <!-- Label Column -->
      <ng-container matColumnDef="Label">
        <th mat-header-cell *matHeaderCellDef>Label</th>
        <td mat-cell *matCellDef="let element">
          <div style="margin-top: 7px">{{ element.Label }}</div>
        </td>
      </ng-container>

      <!-- Level Column -->
      <ng-container matColumnDef="level">
        <th mat-header-cell *matHeaderCellDef>Level</th>
        <td mat-cell *matCellDef="let element">
          <div style="margin-top: 7px" [appTooltip]="tooltipTemplate">
            {{ element.level }}
          </div>
          <ng-template #tooltipTemplate>
            <div
              class="tooltip"
              *ngIf="element.level == 0 || element.level == ' '"
            >
              <div class="flex flex-row background-go">
                <p>Level 0</p>
                <div class="flex flex-row">
                  <img
                    class="tooltip-icon"
                    src="./assets/img/icons/go-tooltip-icon.svg"
                  />
                  <p>Go</p>
                </div>
              </div>
              <div class="flex tooltip-text">Not a Claim</div>
            </div>
            <div class="tooltip" *ngIf="element.level == 1">
              <div class="flex flex-row background-go">
                <p>Level 1</p>
                <div class="flex flex-row">
                  <img
                    class="tooltip-icon"
                    src="./assets/img/icons/go-tooltip-icon.svg"
                  />
                  <p>Go</p>
                </div>
              </div>
              <div class="flex tooltip-text">No Legal Engagement</div>
            </div>
            <div class="tooltip" *ngIf="element.level == 2">
              <div class="flex flex-row background-ask">
                <p>Level 2</p>
                <div class="flex flex-row">
                  <img
                    class="tooltip-icon"
                    src="./assets/img/icons/ask-tooltip-icon.svg"
                  />
                  <p>Ask</p>
                </div>
              </div>
              <div class="flex tooltip-text">
                Seek Legal / Regulatory Engagement
              </div>
            </div>
            <div class="tooltip" *ngIf="element.level == 3">
              <div class="flex flex-row background-no">
                <p>Level 3</p>
                <div class="flex flex-row">
                  <img
                    class="tooltip-icon"
                    src="./assets/img/icons/no-tooltip-icon.svg"
                  />
                  <p>No</p>
                </div>
              </div>
              <div class="flex tooltip-text">Not allowed in Unilever</div>
            </div>
          </ng-template>
        </td>
      </ng-container>

      <!-- Rule/Model Score(%) Column -->
      <ng-container matColumnDef="level_model">
        <th mat-header-cell *matHeaderCellDef>Rule/Model Score(%)</th>
        <td mat-cell *matCellDef="let element">
          @if(element.level_model == 'By Rules'){
          <div style="margin-top: 7px" [appTooltip]="tooltipTemplate">
            {{ element.level_model }}
          </div>
          <ng-template #tooltipTemplate>
            <div class="tooltip-rules">
              <div class="flex flex-row">
                <p>Defined by rules, because</p>
              </div>
              <div class="flex tooltip-text-rules">
                Text contains:&nbsp;
                <span class="tooltip-bold-text">{{
                  element.level_keywords
                }}</span>
              </div>
              <div
                class="flex tooltip-text-rules"
                *ngIf="geographyValue != null"
              >
                Geography: &nbsp;<span class="tooltip-bold-text">{{
                  geographyValue
                }}</span>
              </div>
            </div>
          </ng-template>
          }@else {
          <div
            style="margin-top: 7px"
            [matTooltip]="(element.level_model * 100 | number : '1.2-2') + '%'"
          >
            {{ element.level_model * 100 | number : "1.2-2" }}%
          </div>
          }
        </td>
      </ng-container>

      <!-- Manual Level Column -->
      <ng-container matColumnDef="manual_level">
        <th mat-header-cell *matHeaderCellDef>Manual Level</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-form-field
            appearance="outline"
            style="
              min-width: 60px !important;
              width: 74px !important;
              margin-top: 7px;
            "
            [ngStyle]="{
              cursor:
                element.editing_status_manual_risk === false
                  ? 'not-allowed'
                  : 'pointer'
            }"
          >
            <mat-select
              [(ngModel)]="element.manual_level[0]"
              (valueChange)="onLevelChanged($event, i)"
              [disabled]="element.editing_status_manual_risk === false"
            >
              <mat-option
                *ngFor="let option of manualriskoptions"
                [value]="option"
                style="font-size: 10px"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Risk Column -->
      <ng-container matColumnDef="risk">
        <th mat-header-cell *matHeaderCellDef>Risk</th>
        <td class="risk_color" mat-cell *matCellDef="let element">
          <!-- <span class="risk">{{ element.risk }}</span> -->
          <div *ngIf="element.level == 2" style="margin-top: 9px">
            <span class="risk-0" *ngIf="element.risk == 1">Low</span>
            <span class="risk-1" *ngIf="element.risk == 2">Medium</span>
            <span class="risk-2" *ngIf="element.risk == 3">High</span>
          </div>
        </td>
      </ng-container>

      <!-- Rules/Model Score Column -->
      <ng-container matColumnDef="risk_model">
        <th mat-header-cell *matHeaderCellDef>Rules/Model Score</th>
        <td mat-cell *matCellDef="let element">
          @if(element.risk_model == 'By Rules' || element.risk_model == " "){
          <div style="margin-top: 7px">{{ element.risk_model }}</div>
          <ng-template #tooltipTemplate>
            <div class="tooltip-rules">
              <div class="flex flex-row">
                <p>Defined by rules, because</p>
              </div>
              <div class="flex tooltip-text-rules">
                Text contains:&nbsp;
                <span class="tooltip-bold-text">{{
                  element.risk_keywords
                }}</span>
              </div>
              <div
                class="flex tooltip-text-rules"
                *ngIf="geographyValue != null"
              >
                Geography: &nbsp;<span class="tooltip-bold-text">{{
                  geographyValue
                }}</span>
              </div>
            </div>
          </ng-template>
          }@else {
          <div
            style="margin-top: 7px"
            [matTooltip]="(element.risk_model * 100 | number : '1.2-2') + '%'"
          >
            {{ element.risk_model * 100 | number : "1.2-2" }}%
          </div>
          }
        </td>
      </ng-container>

      <!-- Manual Risk Column -->
      <ng-container matColumnDef="manual_risk">
        <th mat-header-cell *matHeaderCellDef>Manual Risk</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <ng-container *ngIf="element.manual_level == 2; else showNA">
            <mat-form-field appearance="outline" class="w-full">
              <mat-select
                [(ngModel)]="element.manual_risk[0]"
                (valueChange)="onRiskChanged($event, i)"
                [disabled]="element.editing_status_manual_risk === false"
                [ngStyle]="{
                  cursor:
                    element.editing_status_manual_risk === false
                      ? 'not-allowed'
                      : 'pointer'
                }"
              >
                <mat-option
                  *ngFor="let option of optionmanualrisk"
                  [value]="option"
                  style="font-size: 10px"
                >
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

          <ng-template #showNA
            ><div style="margin-top: 7px">NA</div></ng-template
          >
        </td>
      </ng-container>

      <!-- Reason Column -->
      <ng-container matColumnDef="reason">
        <th mat-header-cell *matHeaderCellDef>Reason</th>
        <td mat-cell *matCellDef="let element">
          <div *ngFor="let reason of element.reason" style="margin-top: 7px">
            {{ reason }}
          </div>
        </td>
      </ng-container>

      <!-- Rules/Model Score Column -->
      <ng-container matColumnDef="reason_model">
        <th mat-header-cell *matHeaderCellDef>Rules/Model Score</th>
        <td mat-cell *matCellDef="let element">
          <!-- <div *ngFor="let reason of element.reason_model">
            {{ reason * 100 | number : "1.0-0" }}%
          </div> -->

          @if(element.reason_model == 'By Rules'){
          <div style="margin-top: 7px">{{ element.reason_model }}</div>
          <ng-template #tooltipTemplate>
            <div class="tooltip-rules">
              <div class="flex flex-row">
                <p>Defined by rules, because</p>
              </div>
              <div class="flex tooltip-text-rules">
                Text contains:&nbsp;
                <span class="tooltip-bold-text">{{
                  element.reason_keywords
                }}</span>
              </div>
              <div
                class="flex tooltip-text-rules"
                *ngIf="geographyValue != null"
              >
                Geography: &nbsp;<span class="tooltip-bold-text">{{
                  geographyValue
                }}</span>
              </div>
            </div>
          </ng-template>
          }@else {
          <div
            *ngFor="let reason of element.reason_model"
            style="margin-top: 7px"
            [matTooltip]="(reason * 100 | number : '1.2-2') + '%'"
          >
            {{ reason * 100 | number : "1.2-2" }}%
          </div>
          }
        </td>
      </ng-container>

      <!-- Manual Reason Column -->
      <ng-container matColumnDef="manual_reason">
        <th mat-header-cell *matHeaderCellDef>Manual Reason</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-form-field
            appearance="outline"
            class="w-full"
            style="min-width: 200px !important; margin-top: 7px"
            [ngStyle]="{
              cursor:
                element?.editing_status_reason === false
                  ? 'not-allowed'
                  : 'pointer'
            }"
          >
            <mat-select
              [(ngModel)]="element.manual_reason"
              multiple
              (valueChange)="onReasonChanged($event, i)"
              [disabled]="element?.editing_status_reason === false"
            >
              <mat-option
                *ngFor="let option of reasons"
                [value]="option"
                style="font-size: 10px"
                [disabled]="isOptionDisabled(option, element.manual_reason)"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        style="
          background-color: #f4f7fc;
          color: #49526e;
          height: 30px;
          letter-spacing: 1px;
          font-size: 10px;
          font-weight: bold;
        "
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; let i = index; columns: displayedColumns"
        [ngClass]="{
          tableRow: true,
          'odd-row': i % 2 !== 0,
          'even-row': i % 2 === 0,
          'translation-row': radioBtnValue === 'translation'
        }"
        [attr.data-index]="i"
      ></tr>
    </table>

    <!-- <button *ngIf="hideHeader" mat-stroked-button class="btn-new-row">
      <span class="btn-content">
        <img
          src="assets/images/icons/plus.svg"
          alt="plus-icon"
          class="plus-icon"
        />
        <span class="btn-text"(click)="addNewRow()>Add New Row</span>
      </span>
    </button> -->
  </div>
  <button
    *ngIf="hideHeader"
    mat-stroked-button
    class="btn-new-row"
    (click)="addNewRow()"
  >
    <span class="btn-content">
      <img
        src="assets/images/icons/plus.svg"
        alt="plus-icon"
        class="plus-icon"
      />
      <span class="btn-text">Add New Row</span>
    </span>
  </button>

  <mat-toolbar class="fixed-toolbar">
    <span class="overall-result">Over All Result</span>
    <span class="level">{{ total.level }}</span>

    <!-- Risk Level Display -->
    <span class="risk-buttons">
      <ng-container *ngIf="total.level == 2">
        <span class="risk-0" *ngIf="total.risk == 1">Low</span>
        <span class="risk-1" *ngIf="total.risk == 2">Medium</span>
        <span class="risk-2" *ngIf="total.risk == 3">High</span>
      </ng-container>
      <ng-container *ngIf="total.level != 2">
        {{ total.risk }}
      </ng-container>
    </span>

    <!-- Reasons -->
    <span class="point">
      <span
        class="reason-text"
        *ngFor="let reason of total.reason; let last = last"
      >
        {{ reason }}<span *ngIf="!last"> / </span>
      </span>
    </span>
  </mat-toolbar>
  <p-toast position="bottom-right" key="br" />
  <!-- <app-footer class="footer"></app-footer> -->
  <div class="row">
    <div class="col-sm col-md">
      <app-footer class="footer"></app-footer>
    </div>
  </div>
</div>
